export default "__VITE_ASSET__CiXXcqA___"